import { Material } from '@babylonjs/core/Materials/material';

export const getMaterialIndexFromMetadata = (material: Material) => {
  const gltfMeta = material?.metadata?.gltf?.pointers?.[0];
  if (!gltfMeta) {
    return -1;
  }
  return parseInt(gltfMeta.replace(/^(#)*(\/materials\/)/i, ''));
};
